import { Element } from "@xmpp/xml"
import OpenclawWorkflowsParser, {
  WORKFLOWS_NODE,
} from "./openclawWorkflowsParser"
import { parseFleetReminders } from "./fleetReminderParser"
import { WorkflowJob } from "@/reducers/openclawWorkflowsSlice"
import PubSubEventParser from "./PubSubEventParser"

export type WorkflowPubSubItem = {
  itemId: string
  workflows: WorkflowJob[]
}

function parseWorkflowItem(item: Element): WorkflowPubSubItem {
  const itemId = item.getAttr("id") ?? ""
  const workflows: WorkflowJob[] = [
    ...OpenclawWorkflowsParser.parseItem(item),
    ...parseFleetReminders(item),
  ]
  return { itemId, workflows }
}

export const WorkflowPubSubEventParser =
  new PubSubEventParser<WorkflowPubSubItem>(parseWorkflowItem, WORKFLOWS_NODE)
